import { render, staticRenderFns } from "./InboxComponent.vue?vue&type=template&id=8e8a51b0"
import script from "./InboxComponent.vue?vue&type=script&lang=js"
export * from "./InboxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports